import React, { useState } from 'react';
import { CSVFileEntry } from '../../../../types/common';
import { ColorTheme } from './CSVFileHeader';
import { CompactFileCard } from './CompactFileCard';
import { CSVFileSettingsDrawer } from './CSVFileSettingsDrawer';

interface CSVFileEntryCardProps {
  entry: CSVFileEntry;
  onInputChange: (field: keyof CSVFileEntry, value: string) => void;
  onRadioChange: (value: 'ja' | 'nein', field: 'skalierung' | 'mittelwertbildungÜberDenZeithorizont') => void;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: () => void;
  onUpload?: () => void;
  onSave?: () => void;
  isUploading?: boolean;
  isDirty?: boolean;
  colorTheme?: ColorTheme;
  hasDuplicateBezeichnung?: boolean;
  sessionId?: string;
  indexLabel?: string;
}

/**
 * Complete CSV file entry card component
 * Renders a compact single-line card with a settings drawer for configuration
 * Supports blue (input) and green (output) color themes
 */
export const CSVFileEntryCard: React.FC<CSVFileEntryCardProps> = ({
  entry,
  onInputChange,
  onRadioChange,
  onFileChange,
  onRemove,
  onUpload,
  onSave,
  isUploading = false,
  isDirty = false,
  colorTheme = 'blue',
  hasDuplicateBezeichnung = false,
  sessionId,
  indexLabel,
}) => {
  // State for drawer
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenSettings = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      {/* Compact card */}
      <CompactFileCard
        entry={entry}
        onFileChange={onFileChange}
        onInputChange={onInputChange}
        onRemove={onRemove}
        onUpload={onUpload}
        onOpenSettings={handleOpenSettings}
        onSave={onSave}
        isUploading={isUploading}
        isDirty={isDirty}
        colorTheme={colorTheme}
        hasDuplicateBezeichnung={hasDuplicateBezeichnung}
        sessionId={sessionId}
        indexLabel={indexLabel}
      />

      {/* Settings drawer */}
      <CSVFileSettingsDrawer
        isOpen={isDrawerOpen}
        onClose={handleCloseDrawer}
        entry={entry}
        onInputChange={onInputChange}
        onRadioChange={onRadioChange}
        colorTheme={colorTheme}
        isDirty={isDirty}
        onSave={onSave}
        hasStoragePath={!!entry.storagePath}
      />
    </>
  );
};

export default CSVFileEntryCard;
